import $ from 'jquery';
import { createCartProduct } from './cart-product';

const cart = document.querySelector('#sidebar-cart');
const overlay = document.querySelector('.SidebarCartOverlay');
const opener = document.querySelector('#open-cart-btn');
let readRequest = null;
let mutating = false;
let refreshPending = false;
let revision = 0;
let returnFocus = null;
let scrollPosition = 0;
let previousBodyStyle = '';
let background = [];
let noticeAction = null;
let productView = null;

const isOpen = () => cart && cart.classList.contains('active');
const isBusy = () => mutating || !!readRequest || !!(productView && productView.isLoading());
const focusable = () =>
    Array.from(cart.querySelectorAll('a[href], button, input, summary, [tabindex="0"]')).filter(
        (element) =>
            !element.disabled &&
            element.tabIndex >= 0 &&
            element.getClientRects().length &&
            !element.closest('[inert]'),
    );

const announce = (message = '', type = 'success', action = null) => {
    const notice = cart.querySelector('.SidebarCart__notice');
    notice.hidden = !message;
    notice.classList.toggle('SidebarCart__notice--error', type === 'error');
    cart.querySelector('.SidebarCart__message').textContent = message;
    const button = cart.querySelector('.SidebarCart__noticeAction');
    if (!action && document.activeElement === button && isOpen())
        cart.querySelector('.SidebarCart__close').focus({ preventScroll: true });
    button.hidden = !action;
    button.textContent = action ? action.label : '';
    noticeAction = action ? action.run : null;
};

const setBusy = () => {
    const busy = isBusy();
    cart.classList.toggle('is-loading', busy);
    cart.querySelector('.SidebarCart__body').setAttribute('aria-busy', String(busy));
    cart.querySelector('.SidebarCart__loading').hidden = !busy;
    if (productView) productView.setBusy(busy);
    const checkout = cart.querySelector('[data-cart-focus="checkout"]');
    if (checkout)
        checkout.setAttribute('aria-disabled', String(busy || cart.classList.contains('is-stale')));
};

const render = (data, clearCoupon = false) => {
    if (!data || typeof data.cart_html !== 'string') throw new Error('Invalid cart response');
    const body = cart.querySelector('.SidebarCart__body');
    const scroll = body.querySelector('.SidebarCart__scroll');
    const top = scroll ? scroll.scrollTop : 0;
    const details = body.querySelector('.SidebarCart__coupon');
    const couponOpen = details && details.open;
    const input = body.querySelector('#sidebar-coupon');
    const draft = input && !clearCoupon ? input.value : '';
    const active = document.activeElement;
    const hadFocus = body.contains(active);
    const focusKey = hadFocus ? active.getAttribute('data-cart-focus') : null;
    body.innerHTML = data.cart_html;
    const newScroll = body.querySelector('.SidebarCart__scroll');
    if (newScroll) newScroll.scrollTop = top;
    const newDetails = body.querySelector('.SidebarCart__coupon');
    if (newDetails && couponOpen) newDetails.open = true;
    const newInput = body.querySelector('#sidebar-coupon');
    if (newInput) newInput.value = draft;
    const count = Number(data.cart_count) || 0;
    cart.querySelector('[data-cart-count]').textContent = count;
    document.querySelectorAll('.CartIndicator__dot').forEach((dot) => {
        dot.textContent = count;
    });
    if (opener) opener.setAttribute('aria-label', `Otwórz koszyk. Liczba produktów: ${count}`);
    if (data.nonce) cart.dataset.nonce = data.nonce;
    cart.classList.remove('is-stale');
    document.dispatchEvent(new CustomEvent('ravessa:cart-rendered', {
        detail: { keys: Array.from(body.querySelectorAll('[data-cart-item]'), (item) => item.dataset.cartItem) },
    }));
    if (hadFocus && isOpen()) {
        const next = Array.from(body.querySelectorAll('[data-cart-focus]')).find(
            (element) => element.dataset.cartFocus === focusKey && !element.disabled,
        );
        (next || cart.querySelector('.SidebarCart__close')).focus({ preventScroll: true });
    }
};

const requestError = (xhr) => {
    const data = xhr.responseJSON && xhr.responseJSON.data;
    if (data && data.cart) render(data.cart);
    const needsRefresh = !data || data.refresh || !data.cart;
    cart.classList.toggle('is-stale', needsRefresh);
    announce(
        data && data.message
            ? data.message
            : 'Nie udało się potwierdzić zmiany. Odśwież koszyk i sprawdź jego zawartość.',
        'error',
        needsRefresh
            ? {
                  label: 'Odśwież koszyk',
                  run: () => refreshCart(''),
              }
            : null,
    );
};

const refreshCart = (message = null) => {
    if (!cart) return;
    if (mutating) {
        refreshPending = true;
        return;
    }
    const currentRevision = ++revision;
    if (readRequest) readRequest.abort();
    readRequest = $.ajax({
        url: jsData.ajaxUrl,
        type: 'GET',
        dataType: 'json',
        cache: false,
        timeout: 20000,
        data: { action: 'verenza_get_cart_items' },
    });
    setBusy();
    readRequest
        .done((data) => {
            if (currentRevision !== revision) return;
            try {
                render(data);
                if (message !== null) announce(message);
            } catch (error) {
                requestError({});
            }
        })
        .fail((xhr, status) => {
            if (status !== 'abort' && currentRevision === revision) requestError(xhr);
        })
        .always(() => {
            if (currentRevision !== revision) return;
            readRequest = null;
            setBusy();
        });
    return readRequest;
};

const mutate = (operation, values = {}) => {
    if (isBusy()) return;
    mutating = true;
    revision += 1;
    announce();
    setBusy();
    $.ajax({
        url: jsData.ajaxUrl,
        type: 'POST',
        dataType: 'json',
        timeout: 20000,
        data: {
            action: 'ravessa_sidebar_cart_action',
            operation,
            nonce: cart.dataset.nonce,
            ...values,
        },
    })
        .done((response) => {
            if (!response.success) {
                requestError({ responseJSON: response });
                return;
            }
            const data = response.data;
            try {
                render(data, operation === 'apply_coupon');
                if (operation === 'configure' && productView)
                    productView.close(data.configured_key);
                announce(
                    data.message,
                    'success',
                    data.undo_key
                        ? {
                              label: 'Cofnij',
                              run: () => mutate('restore', { cart_item_key: data.undo_key }),
                          }
                        : null,
                );
                // Keep WooCommerce's header fragments and cached cart count in sync.
                $(document.body).trigger('wc_fragment_refresh');
                $(document.body).trigger('ravessa_cart_updated', [data]);
                if (document.querySelector('form.checkout'))
                    $(document.body).trigger('update_checkout');
            } catch (error) {
                requestError({});
            }
        })
        .fail(requestError)
        .always(() => {
            mutating = false;
            setBusy();
            if (refreshPending) {
                refreshPending = false;
                refreshCart();
            }
        });
};

export const handleOpenCart = (event, message = '') => {
    if (!cart) return;
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    if (!isOpen()) {
        returnFocus = document.activeElement;
        scrollPosition = window.scrollY;
        previousBodyStyle = document.body.getAttribute('style');
        Object.assign(document.body.style, {
            position: 'fixed',
            top: `-${scrollPosition}px`,
            left: '0',
            right: '0',
            width: '100%',
        });
        document.documentElement.classList.add('sidebar-cart-open');
        background = Array.from(document.body.children)
            .filter(
                (element) =>
                    element !== cart &&
                    element !== overlay &&
                    !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName),
            )
            .map((element) => ({ element, inert: element.inert }));
        background.forEach(({ element }) => {
            element.inert = true;
        });
        cart.inert = false;
        cart.setAttribute('aria-hidden', 'false');
        cart.classList.add('active');
        overlay.classList.add('active');
        if (opener) opener.setAttribute('aria-expanded', 'true');
        cart.querySelector('.SidebarCart__close').focus({ preventScroll: true });
    }
    return refreshCart(message);
};

const closeCart = () => {
    if (!isOpen()) return;
    if (productView && productView.isOpen()) productView.close('', false);
    cart.classList.remove('active');
    overlay.classList.remove('active');
    background.forEach(({ element, inert }) => {
        element.inert = inert;
    });
    background = [];
    document.documentElement.classList.remove('sidebar-cart-open');
    if (previousBodyStyle === null) document.body.removeAttribute('style');
    else document.body.setAttribute('style', previousBodyStyle);
    window.scrollTo({ top: scrollPosition, behavior: 'instant' });
    if (opener) opener.setAttribute('aria-expanded', 'false');
    const target = returnFocus && returnFocus.isConnected ? returnFocus : opener;
    if (target) target.focus({ preventScroll: true });
    cart.inert = true;
    cart.setAttribute('aria-hidden', 'true');
};

if (cart) {
    document.addEventListener('ravessa:open-cart', () => handleOpenCart(null));
    document.addEventListener('ravessa:close-cart', closeCart);
    productView = createCartProduct({
        cart,
        isBusy,
        isStale: () => cart.classList.contains('is-stale'),
        setBusy,
        announce,
        mutate,
    });
    document.addEventListener('ravessa:configure-product', (event) => {
        const id = Number(event.detail && event.detail.productId);
        if (!Number.isInteger(id) || id < 1 || mutating) return;
        const request = handleOpenCart(null);
        if (request)
            request.done(() => {
                if (isOpen() && !isBusy() && !cart.classList.contains('is-stale'))
                    productView.open({ dataset: { cartProduct: String(id) } });
            });
    });
    if (opener) opener.addEventListener('click', handleOpenCart);
    overlay.addEventListener('click', closeCart);
    cart.addEventListener('click', (event) => {
        const close = event.target.closest('[data-cart-close]');
        if (close) {
            closeCart();
            return;
        }
        const actionButton = event.target.closest('.SidebarCart__noticeAction');
        if (actionButton) {
            if (!isBusy() && noticeAction) noticeAction();
            return;
        }
        if (isBusy() || cart.classList.contains('is-stale')) {
            if (event.target.closest('button, input, summary, [data-cart-focus="checkout"]'))
                event.preventDefault();
            return;
        }
        const quantity = event.target.closest('[data-cart-quantity]');
        const product = event.target.closest('[data-cart-product]');
        if (product) productView.open(product);
        const remove = event.target.closest('[data-cart-remove]');
        const coupon = event.target.closest('[data-cart-remove-coupon]');
        if (quantity)
            mutate('quantity', {
                cart_item_key: quantity.dataset.key,
                quantity: quantity.dataset.cartQuantity,
            });
        if (remove) mutate('remove', { cart_item_key: remove.dataset.cartRemove });
        if (coupon) mutate('remove_coupon', { coupon_code: coupon.dataset.cartRemoveCoupon });
    });
    cart.addEventListener('change', (event) => {
        const input = event.target.closest('.CartItem__quantityInput');
        if (!input) return;
        if (isBusy() || cart.classList.contains('is-stale')) {
            input.value = input.dataset.current;
            return;
        }
        if (!input.checkValidity() || !Number.isInteger(Number(input.value))) {
            input.reportValidity();
            input.value = input.dataset.current;
            announce(
                'Wybierz dostępną liczbę sztuk. Produkt usuniesz przyciskiem „Usuń”.',
                'error',
            );
            return;
        }
        if (input.value !== input.dataset.current)
            mutate('quantity', { cart_item_key: input.dataset.key, quantity: input.value });
    });
    cart.addEventListener('submit', (event) => {
        if (!event.target.matches('.SidebarCart__couponForm')) return;
        event.preventDefault();
        if (isBusy() || cart.classList.contains('is-stale')) return;
        const input = event.target.querySelector('input');
        if (input.value.trim()) mutate('apply_coupon', { coupon_code: input.value.trim() });
    });
    document.addEventListener('keydown', (event) => {
        if (!isOpen()) return;
        if (event.key === 'Enter' && event.target.matches('.CartItem__quantityInput')) {
            event.preventDefault();
            event.target.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (event.key === 'Escape') {
            event.preventDefault();
            if (productView.isOpen() && !mutating) productView.close();
            else closeCart();
        }
        if (event.key === 'Tab') {
            const elements = focusable();
            const first = elements[0];
            const last = elements[elements.length - 1];
            if (!elements.length) {
                event.preventDefault();
                cart.focus();
                return;
            }
            if (
                event.shiftKey &&
                (document.activeElement === first || !cart.contains(document.activeElement))
            ) {
                event.preventDefault();
                last.focus();
            } else if (
                !event.shiftKey &&
                (document.activeElement === last || !cart.contains(document.activeElement))
            ) {
                event.preventDefault();
                first.focus();
            }
        }
    });
    // Product-page quick-add confirms inline, while keeping the same cart presentation in sync.
    $(document.body).on('ravessa:cart-updated.ravessaSidebar', (event, data) => {
        if (mutating) {
            refreshPending = true;
            return;
        }
        revision += 1;
        if (readRequest) readRequest.abort();
        readRequest = null;
        render(data);
        setBusy();
    });
    $(document.body).on('added_to_cart.ravessaSidebar', () => {
        if (!document.querySelector('#added-to-cart-popup[data-ready="true"]'))
            handleOpenCart(null, 'Dodano do koszyka. Dobry wybór!');
    });
    $(document.body).on(
        'updated_cart_totals.ravessaSidebar wc_cart_emptied.ravessaSidebar updated_wc_div.ravessaSidebar',
        () => {
            if (isOpen()) refreshCart();
        },
    );
    window.addEventListener('pageshow', (event) => {
        if (event.persisted && isOpen()) refreshCart();
    });
}
